import storage from "/@/cool/utils/storage";
import { normalizeLang } from "/@/utils/normalizeLang";

/** 读取 i18next 语言缓存（兼容 store JSON 编码与原生 localStorage 纯文本） */
export function readStoredI18nextLng(): string {
	if (typeof localStorage !== "undefined") {
		const raw = localStorage.getItem("i18nextLng");
		if (raw) {
			try {
				const parsed = JSON.parse(raw);
				if (typeof parsed === "string") {
					return parsed;
				}
			} catch {
				// i18next-browser-languagedetector 写入的纯文本格式
			}
			return raw;
		}
	}

	return storage.get("i18nextLng") || "";
}

export function getCurrentLang(url?: string) {
	const href = url || (typeof window === "undefined" ? "" : window.location.href);
	let urlLang = "";

	if (href) {
		try {
			urlLang = new URL(href, typeof window === "undefined" ? undefined : window.location.href)
				.searchParams.get("lang") || "";
		} catch {
			urlLang = "";
		}
	}

	// i18nextLng 是语言切换的权威来源，优先于 lang（两者可能短暂不同步）
	const lang = normalizeLang(urlLang || readStoredI18nextLng() || storage.get("lang"));

	if (lang) {
		storage.set("lang", lang);
		if (typeof localStorage !== "undefined") {
			localStorage.setItem("i18nextLng", lang);
		}
	}

	return lang;
}
